/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
//@ts-ignore
import {GetProductsBySlugs,OrderProductsByPrice,GetRidersBySlugs} from './../../themes/kent/utilities/dataFunctions';
// @ts-ignore
import PortalModal from './../portal-modal/./portal-modal';
// @ts-ignore
import TaggedImageOverlay from './../tagged-image-overlay/./tagged-image-overlay';

//@ts-ignore
import {GeneralAssetUrl} from './../../themes/kent/utilities/constants';
// @ts-ignore
import {GenerateProductAssetUrl} from './../../themes/kent/utilities/functions';

interface IProps {
  image?:string;
  products?:any;
  athletes?:any;
  height?:any;
  style?:any;
  year?:any;
}

interface IState {
  ready?:boolean;
  onBackgroundImageLoaded?:boolean;
  fullScreen?:boolean;
  athletes?:any;
  products?:any;
  thumbs?:any;
}

/**
 *
 * Tagged Image component
 * @extends {React.Component}
 */

class HosportsTaggedImage extends React.Component<IProps> {

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      ready:false,
      onBackgroundImageLoaded:false,
      fullScreen:false,
      athletes:[],
      products:[],
      thumbs:[]
    };
  }

  public componentDidMount = async() => {
    let riderArray = [];
    let productArray = [];
    if(this.props.products){
      for (var i = 0; i < this.props.products.length; i++) {
        productArray.push(this.props.products[i])
      }
    }
    if(this.props.athletes){
      for (var i = 0; i < this.props.athletes.length; i++) {
        riderArray.push(this.props.athletes[i])
      }
    }
    let products = await GetProductsBySlugs(productArray,this.props.year);
    let athletes = await GetRidersBySlugs(riderArray);
    let prodAssetUrl = await GenerateProductAssetUrl(this.props.year)
    let thumbs = [];
    for (let index = 0; index < products.length; index++) {
      let thumb = prodAssetUrl+products[index].attributes.slug+'1_500.png';
      thumbs.push(thumb)
    }
    this.setState({
      products:products,
      athletes:athletes,
      thumbs:thumbs
    })
  }

  public onBackgroundImageLoad = () => {
    this.setState({
      onBackgroundImageLoaded:true
    })
  }

  public activateFullScreen = () => {
    this.setState({
      fullScreen:true
    })
  }

  public hideFullScreen = () => {
    this.setState({
      fullScreen:false
    })
  }

  public render(): JSX.Element {
    let backgroundImageLoadedClass:string = "loaded";
    if(!this.state.onBackgroundImageLoaded){
      //backgroundImageLoadedClass = ""
    }
    let heightClass:string = "";
    if(this.props.height){
      heightClass = this.props.height+'-height';
    }
    return (
      <div className={"tagged-image-overlay-container "+heightClass} >
        {this.props.image && <img className="tagged-image-background-preload" src={this.props.image} onLoad={this.onBackgroundImageLoad} />}
        {this.props.image && <div className={"tagged-image-original-image "+backgroundImageLoadedClass} style={{backgroundImage:'url('+this.props.image+')'}} />}
        <div className="tagged-image-tint tint"></div>
        <div className="tagged-image-tag-hover-icon" onClick={this.activateFullScreen} >
          <div style={{width:'100%'}}>
            <div className="tagged-image-tag-hover-icon-item-row">
              {this.state.thumbs && this.state.thumbs.map((thumb:any) =>{
                return(<img className="tagged-image-tag-hover-icon-item" src={thumb} />)
              })}
            </div>
            <h5 className="white-color centered-text" style={{width:'100%', minWidth:'100%', maxWidth:'100%', marginTop:30,color:'#fff'}}>{'Shop This Look'}</h5>
          </div>
        </div>
        {this.state.fullScreen &&
          <PortalModal
            modalHidden={this.hideFullScreen}
            modalActive={this.state.fullScreen}
            content={
              <TaggedImageOverlay year={this.props.year} athletes={this.state.athletes} products={this.state.products} image={this.props.image} />
            }
          />
        }
      </div>
    );
  }
}

export default HosportsTaggedImage;
